import type { ReactElement } from "react";
import type { PageContext } from "../hooks/usePageContext";

interface ChatContextPillProps {
	context: PageContext;
	/** True when the user navigated away from the thread's original context. */
	drifted?: boolean;
}

export function ChatContextPill({
	context,
	drifted,
}: ChatContextPillProps): ReactElement | null {
	let label: string | null = null;

	if (context.pageType === "project" && context.projectName) {
		label = context.projectName;
	} else if (context.pageType === "project" && context.projectId) {
		label = "Current project";
	} else if (context.pageType === "document") {
		label = context.documentTitle ?? "Current document";
	} else if (context.pageType === "content") {
		label = context.contentTitle ?? "Current content";
	}

	if (!label) return null;

	return (
		<div
			data-testid="chat-context-pill"
			data-drifted={drifted ? "true" : "false"}
			className={`flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] ${
				drifted
					? "border-accent-dim text-accent"
					: "border-line text-fg-ghost"
			}`}
		>
			<span
				className={`inline-block h-1.5 w-1.5 rounded-full ${
					drifted ? "bg-accent" : "bg-fg-ghost"
				}`}
			/>
			<span className="max-w-[200px] truncate">{label}</span>
		</div>
	);
}
